///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item = abcsetup.rx_item || {};
abcsetup.rx_item.edit = abcsetup.rx_item.edit || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.edit.removeButtons = [];
abcsetup.rx_item.edit.removeButtonsFieldTeam = [];




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.edit = {
    init: function() {
        abcsetup.setTitle('Edit Rx Item');
        abcsetup.rx_item.edit.removeButtons = ['maintenance_approve_screenshot'];
        abcsetup.rx_item.edit.removeButtonsFieldTeam = ['hda_form', 'case_label', 'flat_product_bar_code_image'];

        // Set the global item var
        abcsetup.item = JSON.parse($('form.rx-item #item_object').html());
        abcsetup.form_manager.form = $('form.rx-item');
        abcsetup.form_manager.setFormItems();

        // Disable the approve button when rejecting
        $('#reject-btn-dropdown').on('shown.bs.dropdown', function () {
            $('div.right .buttons .btn-approve').attr('disabled', true);
        }).on('hidden.bs.dropdown', function () {
            $('div.right .buttons .btn-approve').attr('disabled', false);
        });

        // Disable mousewheel incrementing on number input fields for
        // Chromium based browsers (Edge, Chrome)
        $('form').on('focus', 'input[type=number]', function (e) {
            $(this).on('wheel.disableScroll', function (e) {
            e.preventDefault()
            })
        })

        $('form').on('blur', 'input[type=number]', function (e) {
            $(this).off('wheel.disableScroll')
        })


        // Init any field restrictions/values
        this._initFields();

        // Init the GTIN Grid
        this._initGTIN();

        // Init the SAP Divisions
        this._initSAPDiv();

        // Init the attachment buttons
        this._initAttachments();

        // Bind the reject dropdown events
        this._bindRejectDropdown();

        $('form').on('change', '#change_sds_attachment_type', function (e) {
            let val = '';
            if ($(this).val() == 'msds_sheet') {
                val = 'Y';
                const attachmentId = $('input[data-idx="sds_waiver"]').val();

                $('button#msds_sheet').removeClass('required btn-danger').hide();
                $('input[data-idx="msds_sheet"]').show().val(attachmentId);

                const attachmentName =  $('.sds_waiver[data-type="sds_waiver"]').html().replace(/SDS Waiver/g, "SDS Sheet/Non Hazard Letter");
                $('.sds_waiver[data-type="sds_waiver"]').html(attachmentName);

                $('.sds_waiver[data-type="sds_waiver"]').removeClass('sds_waiver').addClass('msds_sheet').attr('data-type', 'msds_sheet');

                $('input[data-idx="sds_waiver"]').hide();
            }
            else if ($(this).val() == 'sds_waiver') {
                val = 'N';
                const attachmentId = $('input[data-idx="msds_sheet"]').val();

                $('button#sds_waiver').removeClass('required btn-danger').remove();
                $('input[data-idx="sds_waiver"]').show().val(attachmentId);

                const attachmentName = $('.msds_sheet[data-type="msds_sheet"]').html().replace(/SDS Sheet\/Non Hazard Letter/g, "SDS Waiver");
                $('.msds_sheet[data-type="msds_sheet"]').html(attachmentName);

                $('.msds_sheet[data-type="msds_sheet"]').removeClass('msds_sheet').addClass('sds_waiver').attr('data-type', 'sds_waiver');

                $('input[data-idx="msds_sheet"]').hide();
            }

            if (val != '' && val != $('#sds_waiver').val()) {
                $('#sds_waiver').val(val).trigger("change");
            }
        });

        // Delete attachment button clicked
        $(document).on('click', '.delete-attachment', function(event) {
            event.preventDefault();
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Attachment', 'Are you sure you want to delete this attachment?', function (resp) {
                if (resp) {
                    _this.parent().fadeOut('slow', function() {
                        $(this).remove();

                        // Auto save the item form
                        abcsetup.rx_item.edit._autoSave();
                        $('button#'+_this.attr("id")).addClass('required btn-danger').show();
                    });
                }
            });
        });

        $(document).on('change', '#product_regulated_cfr', function() {
            if ($(this).val() == 'N' || $(this).val() == '') {
                $('#hazmat_id_cfr').val('');
                $('#un_id_cfr').val('');
                $('#hazard_class_cfr').val('');
                $('#pack_group_cfr').val('');
                $('#shipping_name_1_cfr').val('');
                $('#label_code_cfr').val('');
                $('#qty_limit_par_cfr').val('');
                $('#qty_limit_cao_cfr').val('');
                $('#vessel_stowage_location_cfr').val('');
                $('#vessel_stowage_other_cfr').val('');
            }
        });

        $(document).on('change', '#product_regulated_iata', function() {
            if ($(this).val() == 'N' || $(this).val() == '') {
                $('#hazmat_id_iata').val('');
                $('#un_id_iata').val('');
                $('#shipping_name_iata').val('');
                $('#descr_iata').val('');
                $('#pack_group_iata').val('');
            }
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all rx item form related JS is handled in the global /forms/_rx_item.js form namespace
        abcsetup.rx_item.form.init(true);
    },

    /**
     * Bind the reject dropdown events
     */
    _bindRejectDropdown: function () {
        $('.dropdown-menu.reject input.checkbox').prop('checked', false);

        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
        });

        $(document).on('click', '.dropdown-menu.reject input.checkbox', function () {
            if ($(this).prop('checked')) {
                $(this).closest('div.checkbox').find('textarea').show();
            } else {
                $(this).closest('div.checkbox').find('textarea').hide().next('.errorMsg').remove();
            }
        });
    },

    /**
     * Init any field restrictions/values
     */
    _initFields: function() {
        require('./_common_rules');
    },

    /**
     * Init the attachment buttons
     */
    _initAttachments: function() {
        $(abcsetup.rx_item.edit.removeButtons).each(function() {
            $('button#' + this).remove();
            $('input[data-idx="' + this + '"]').remove();
        });

        if (abcsetup.userRole.class == 'field_team') {
            $(abcsetup.rx_item.edit.removeButtonsFieldTeam).each(function() {
                $('button#' + this).remove();
                $('input[data-idx="' + this + '"]').remove();
            });
        }

        // Manually apply showIf rules to buttons and their input fields
        $('button#sds_waiver, input[data-idx="sds_waiver"]').attr('showIf', 'sds_waiver=N');
        abcsetup.fieldLib.bindElement($('button#sds_waiver, input[data-idx="sds_waiver"]'), 'showIf');

        $('button#msds_sheet, input[data-idx="msds_sheet"]').attr('showIf', 'sds_waiver=Y');
        abcsetup.fieldLib.bindElement($('button#msds_sheet, input[data-idx="msds_sheet"]'), 'showIf');

        $('button#fda_waiver, input[data-idx="fda_waiver"]').attr('showIf', 'fda_exempt=Y');
        abcsetup.fieldLib.bindElement($('button#fda_waiver, input[data-idx="fda_waiver"]'), 'showIf');

        $('button#sap_pricing_letter, input[data-idx="sap_pricing_letter"]').attr('showIf', '(_USER_CLASS_=bluepoint_cm)|(_INIT_CLASS_=bluepoint_cm)');
        abcsetup.fieldLib.bindElement($('button#sap_pricing_letter, input[data-idx="sap_pricing_letter"]'), 'showIf');

        $('button#ahp_pricing_letter, input[data-idx="ahp_pricing_letter"]').attr('showIf', '((_USER_CLASS_=bluepoint_cm|_INIT_CLASS_=bluepoint_cm)&bluepoint_notify=AHP)');
        abcsetup.fieldLib.bindElement($('button#ahp_pricing_letter, input[data-idx="ahp_pricing_letter"]'), 'showIf');

        $('button#mwi_pricing_letter, input[data-idx="mwi_pricing_letter"]').attr('showIf', '(_USER_CLASS_=bluepoint_cm|_INIT_CLASS_=bluepoint_cm)&bluepoint_notify=MWI');
        abcsetup.fieldLib.bindElement($('button#mwi_pricing_letter, input[data-idx="mwi_pricing_letter"]'), 'showIf');

        $('button#pr_registration_doc, input[data-idx="pr_registration_doc"]').attr('showIf', 'pr_registration=Y');
        abcsetup.fieldLib.bindElement($('button#pr_registration_doc, input[data-idx="pr_registration_doc"]'), 'showIf');

        $('button#short_dated_offer_letter, input[data-idx="short_dated_offer_letter"]').attr('showIf', 'item_setup_reason=Short Dated');
        abcsetup.fieldLib.bindElement($('button#short_dated_offer_letter, input[data-idx="short_dated_offer_letter"]'), 'showIf');
    },


    /**
     * Init the GTIN Grid
     */
    _initGTIN: function() {
        require('./_gtin_grid');

        //$('#gtin_grid_items:not(.read-only) table').show();
        if (abcsetup.item.gtin_items && abcsetup.item.gtin_items.length) {
            $(abcsetup.item.gtin_items).each(function() {
                var row = $('#gtin_grid_items:not(.read-only) table').find('input:checkbox[value="' + this.level_id + '"]').closest('tr');
                row.find('input.form-check-input').prop('checked', true);
                row.find('input.level_name').val(this.level_name);
                row.find('.gtin_saleable_unit').val(this.saleable_unit);
                row.find('.gtin_rfid_tag').val(this.rfid_tag);
                row.find('.gtin_qty').val(this.qty);
                row.find('.gtin_grid_gtin_14').val(this.gtin_14);
                row.find('.gtin_grid_hibcc').val(this.hibcc);
                row.find('.mgf').val(this.mgf);
            });
        }
    },

    /**
     * Init the SAP divisions
     */
    _initSAPDiv: function() {
        require('./_sap_divisions');

        //$('#gtin_grid_items:not(.read-only) table').show();
        if (abcsetup.item.s_a_p_div && abcsetup.item.s_a_p_div.length) {
            $(abcsetup.item.s_a_p_div).each(function() {
                var row = $('#sap_divisions_items:not(.read-only) table').find('input:checkbox[value="' + this.division + '"]').closest('tr');
                row.find('input.form-check-input').prop('checked', true);
                row.find('input.division_name').val(this.level_name);
                row.find('.batch_management').val(this.batch_management);
                row.find('.replace_item').val(this.replace_item);
                row.find('.replace_sap_num').val(this.replace_sap_num);
                row.find('.mpi').val(this.mpi);
            });
        }
    },

    /**
     * Reject the item
     */
    _rejectItem: function () {
        let error = false;
        const checkedItems = $('.dropdown-menu.reject input:checkbox:checked');

        //Click to Reject item
        if (checkedItems.length == 0) {
            abcsetup.alerts.show('Reject Error', 'Please select at least 1 reason to reject the item');
            return false;
        }

        // Validate the rejection reasons
        checkedItems.each(function () {
            const rejectReasonField = $('textarea[name="reject_reason_text[' + $(this).attr('value') + ']"].required');
            if (rejectReasonField.length > 0 && !rejectReasonField.val()) {
                error = true;
                rejectReasonField.addClass('error');
            }
        });

        if (error) {
            return false;
        }

        $('#reject-btn').unbind('click').attr('type', 'submit').trigger('click');
    },

    /**
     * Auto save the item form
     */
    _autoSave: function() {
        $('form.rx-item').append('<input type="hidden" class="tmp-action" name="form_action" value="update">');
        axios.post('/rx_item/' + abcsetup.item.id + '?auto=t', $('form.rx-item').serialize()).then(response => {
            $('form.rx-item').find('.tmp-action').remove();
        });
    },
}
